// extracted by mini-css-extract-plugin
export var aniSpin = "y_d";
export var el = "y_b";